export { default as SupportingChart } from './component';
